import {
  Box, FormControl, RadioGroup, FormControlLabel, Radio, Card, Grid, Container,
} from '@mui/material';
import styles from './AnimationSetting.module.css';

interface Props {
  animation: string,
  onAnimationChange: (animation: string) => void,
}

export default function AnimationSetting(props: Props) {
  const { animation, onAnimationChange } = props;

  return (
<Box>
        <h3>Animation</h3>
        <br />
        <h6>Animation effects when scrolling.</h6>
        <br />
        <hr />
        <h3>Effect</h3>

        <br />
        <FormControl component="fieldset">
            <RadioGroup
              aria-label="audio"
              defaultValue=""
              onChange={(e) => onAnimationChange(e.target.value)}
              value={animation || ''}
            >
                <FormControlLabel value="" control={<Radio />} label="None" />
                <FormControlLabel value="fade-in" control={<Radio />} label="Fade In" />
                <FormControlLabel value="slide-up" control={<Radio />} label="Slide Up" />
                <FormControlLabel value="slide-down" control={<Radio />} label="Slide Down" />
                <FormControlLabel value="zoom-out" control={<Radio />} label="Zoom Out" />
                <FormControlLabel value="zoom-in" control={<Radio />} label="Zoom In" />
            </RadioGroup>
        </FormControl>

        <br />
        <hr />

        <Card sx={{ minWidth: 275 }}>
          <Container sx={{ padding: 10 }}>
            <Grid container justifyContent="center">
              <Grid className={styles.sampleItem.concat(' animation-block-fade-in')} item>
                <Box className={styles.sampleItemText}>Fade in</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-slide-up')} item>
                <Box className={styles.sampleItemText}>Slide up</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-slide-down')} item>
                <Box className={styles.sampleItemText}>Slide down</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-zoom-out')} item>
                <Box className={styles.sampleItemText}>Zoom out</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-zoom-in')} item>
                <Box className={styles.sampleItemText}>Zoom in</Box>
              </Grid>
            </Grid>
          </Container>
        </Card>
    </Box>
  );
}
